export default __webpack_public_path__ + "static/media/close.8ef8db9e.svg";